export const home_i18n = {
    text1: "Invia il tuo primo check-in da firmare",
    text2: "Il check-in virtuale raccoglie i dati biometrici dell'ospite e li collega alla sua prenotazione.",
    text3: "Invia check-in",
    text4: 'Home',
    text5: "Check-in",
    text6: "Benvenuto",
    text7: "Configurazione del check-in",
    text8: "il mio account",
    text9: "Configurazione del check-in",
    text10: "Esci",
    text11: "Immagine dell'hotel",
    text12: "Politiche dell'hotel",
    text13: "messaggi di benvenuto",
    text14: "Carica il logo del tuo hotel",
    text15: "Seleziona o trascina il logo",
    text16: "Annulla",
    text17: "Nome dell'hotel",
    text18: "Salva le modifiche",
    text19: "Cambia logo",
    text20: "Scarica",
    text21: "Cronologia delle firme",
    text22: "Pannello di controllo dei documenti firmati dagli ospiti.",
    text23: "Filtro:",
    text24: "Disabilitato",
    text25: "Per data",
    text26: "Per paese",
    text27: "Nome",
    text28: "Cognome",
    text29: "Nazionalità",
    text30: "Data di check-in",
    text31: "Sincronizzato",
    text32: "Opzioni",
    text33: "Nessun dato",
    text34: "Righe per pagina:",
    text35: "Cerca",
    text36: "Paesi",
    text37: "Da",
    text38: "A",
    text39: "COPYRIGHT © 2022 , Tutti i diritti riservati WACheckines",
    text40: "Fatto con",
    text41: "Esporta",
    text42: "Vedi dettaglio",
    text43: "Visualizza PDF firmato",
    text44: "Elimina",
    text45: "Seleziona un'opzione",
    //aca
    text46: "Aggiungi un metodo di pagamento",
    text47: "Registra o aggiorna il metodo di pagamento con cui verranno effettuati gli addebiti mensili.",
    text48: "Debito totale",
    text49: "Pagamento riuscito",

    p1: "Stai utilizzando la versione di prova",
    p2: "Hai",
    p3: "giorni rimanenti!",
    p4: "Il periodo di prova è terminato.",
    p5: "Abbonati ora",
    p6: "La tua prova gratuita è terminata!",

};